 
import React, {useEffect, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
import {Redirect} from 'react-router';
import {agentDeveloperUtils} from 'wobi-web-common/dist/components/utils/helpers';
import InitialDetailsStep from '../steps/InitialDetailsStep';
import OffersStep from '../steps/OffersStep';
import CompleteDetailsStep from '../steps/CompleteDetailsStep';
import PaymentStep from '../steps/PaymentStep';
import ThankYouStep from '../steps/ThankYouStep';
import {PageNotFound} from 'wobi-web-common';
import {setOffersFields} from '../utils/persistOfferDetails';

const Routes = ({location, changeSideBar}) => {
  const [searchParameters, setSearchParameters] = useState('');
  const [otpFirst, setOtpFirst] = useState(false);
  const [renderReady, setRenderReady] = useState(false);

  useEffect(() => {
    if (agentDeveloperUtils.isOtpFirstInUrl(location)) {
      setSearchParameters(location.search);
      const token = new URLSearchParams(location.search).get('token');
      setOffersFields({token});
      redirectOnOtpFirst();
    }
    setRenderReady(true);
  }, [location]);

  const redirectOnOtpFirst = async () => {
    setOffersFields({otp: 'first'});
    setOtpFirst(true);
    sessionStorage.setItem('otpFirst', true);
  };

  return (
    <Switch>
      <Route exact path='/details' render={(props) => <InitialDetailsStep {...props} changeSideBar={changeSideBar} />} />
      <Route exact path='/initial-details' render={(props) => <InitialDetailsStep {...props} changeSideBar={changeSideBar} />} />
      <Route exact path='/'>
        {!renderReady ? null : otpFirst ?
          searchParameters ? (
            <Redirect to={'/details#destination' + searchParameters} />
          ) : null :
          (
            <Redirect to='/details#destination' />
          )}
      </Route>
      <Route exact path='/offers' render={(props) => <OffersStep {...props} changeSideBar={changeSideBar} />} />
      <Route exact path='/complete-details' render={(props) => <CompleteDetailsStep {...props} changeSideBar={changeSideBar} />} />
      <Route exact path='/payment' render={(props) => <PaymentStep {...props} changeSideBar={changeSideBar} />} />
      <Route exact path='/thank-you' render={(props) => <ThankYouStep {...props} changeSideBar={changeSideBar} />} />
      <Route exact path='*' component={PageNotFound} />
    </Switch>
  );
};

export default Routes;

